import React, { ReactElement } from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { SOURCE_TYPES, SourceContextProvider } from '../contexts/SourceContext';
import AuthProviderList from './AuthProviderList';

export interface AuthScreenProps {
  appBrandingUrl?: string;
  customReturnUrl: string;
  targetAuthProviderId: string;
  appKey: string;
  orgKey: string;
  openInNewTab?: boolean;
  showFooter?: boolean;
  source?: SOURCE_TYPES;
}

/**
 * AuthScreen component that encapsulates all auth provider setup and context providers.
 * except for the ApplicationContextProvider.
 *
 * Use cases: web-app
 */
const AuthScreen = ({
  appBrandingUrl,
  customReturnUrl,
  targetAuthProviderId,
  appKey,
  orgKey,
  openInNewTab = true,
  showFooter = false,
  source,
}: AuthScreenProps): ReactElement => {
  return (
    <SourceContextProvider source={source}>
      <SafeAreaProvider>
        <AuthProviderList
          appBrandingUrl={appBrandingUrl}
          customReturnUrl={customReturnUrl}
          targetAuthProviderId={targetAuthProviderId}
          appKey={appKey}
          orgKey={orgKey}
          openInNewTab={openInNewTab}
          showFooter={showFooter}
        />
      </SafeAreaProvider>
    </SourceContextProvider>
  );
};

export default AuthScreen;
